import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register']

function isOrgOpened(org) {
  if (!org) return false
  if (org.type === 'tourism' || org.type === 'education') return true
  return Number(org.audit_status) === 2
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  if (!hasToken) {
    if (whiteList.includes(to.path)) next()
    else next(`/login?redirect=${to.path}`)
    return
  }

  if (!store.getters.user || store.getters.org == null) {
    try {
      await store.dispatch('user/getInfo')
    } catch (e) {
      await store.dispatch('user/resetToken')
      next(`/login?redirect=${to.path}`)
      NProgress.done()
      return
    }
  }

  const opened = isOrgOpened(store.getters.org)
  if (!opened) {
    if (to.path === '/pending') next()
    else next({ path: '/pending' })
    return
  }

  if (to.path === '/pending' || to.path === '/login' || to.path === '/register') {
    next({ path: '/dashboard' })
    NProgress.done()
    return
  }
  next()
})

router.afterEach(() => NProgress.done())
